/**
 * Import required libraries
 */
import { createStore, applyMiddleware } from "redux";
import { reducers } from "Utils";
import createSagaMiddleware from "redux-saga";

/**
 * Import required elements
 */
import logger from "./logger";

const sagaMiddleware = createSagaMiddleware();

if (process.env.NODE_ENV === "development") {
  window.store = createStore(
    reducers,
    applyMiddleware(sagaMiddleware)
  );
  sagaMiddleware.run(logger);
} else {
  window.store = createStore(reducers);
}

export default window.store;
